import { render, staticRenderFns } from "./pick-digit.vue?vue&type=template&id=5a797d2f"
import script from "./pick-digit.vue?vue&type=script&lang=js"
export * from "./pick-digit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a797d2f')) {
      api.createRecord('5a797d2f', component.options)
    } else {
      api.reload('5a797d2f', component.options)
    }
    module.hot.accept("./pick-digit.vue?vue&type=template&id=5a797d2f", function () {
      api.rerender('5a797d2f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/lotto/pick-digit.vue"
export default component.exports